import React from "react";
import Select from "react-select";

class Selector extends React.Component {
  state = {
    selectedOption: null,
  };

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    this.props.onUpdateValue(selectedOption);
  };

  render() {
    const { options = [], placeholder, value, isLoading = false } = this.props;

    return (
      <Select
        placeholder={placeholder}
        className="col-xs-12 col-lg-4 ml-0 pl-0 pt-2"
        isClearable
        value={value}
        isLoading={isLoading}
        onChange={(value) => this.handleChange(value)}
        options={options}
      />
    );
  }
}

export default Selector;
